import { get, isEmpty } from 'lodash'

const transformToUpdateFoodMoodImageDetailsArgs = data => ({
  image: isEmpty(data.image)
    ? null
    : get(data, 'image[0].originFileObj', undefined),
})

export default transformToUpdateFoodMoodImageDetailsArgs
